/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

/**
 * přejmenuje názvy vlastností objektu - přidá jim suffix
 * @param obj objekt
 * @param suffix suffix
 */
export function addSuffixToKeys(obj: any, suffix: string): any {
  const keyValues = Object.keys(obj).map((key) => ({
    [`${key}${suffix}`]: obj[key],
  }));
  return Object.assign({}, ...keyValues);
}

/**
 * přejmenuje názvy vlastností objektu - odebere jim suffix
 * @param obj objekt
 * @param suffix suffix
 */
export function removeSuffixFromKeys(obj: any, suffix: string): any {
  const keyValues = Object.keys(obj).map((key) => ({
    [key.substring(0, key.lastIndexOf(suffix))]: obj[key],
  }));
  return Object.assign({}, ...keyValues);
}

export const customSorterName = (
  a: any,
  b: any,
  name: string,
  prop: string
): number =>
  a[name] && b[name] ? customSorter(a[name], b[name], prop) : a[name] ? 1 : -1;

export const customSorter = (a: any, b: any, prop: string) =>
  a && a[prop] && b && b[prop]
    ? a[prop].localeCompare(b[prop])
    : a && a[prop]
    ? 1
    : -1;

export const dateSorter = (a: any, b: any, name: string): number =>
  customSorterName(a, b, name, "date");

export const defaultSorter = (a: any, b: any): number =>
  a && b ? a.localeCompare(b) : a ? 1 : -1;

export const integerSorterName = (
  a: any,
  b: any,
  name: string,
  prop: string
): number =>
  a[name] && b[name]
    ? integerSorter(a[name][prop], b[name][prop])
    : a[name][prop]
    ? 1
    : -1;

export const integerSorter = (a: number, b: number): number =>
  a > b ? -1 : a < b ? 1 : 0;
